/**
 * 権限フラグ（フロント側の判定用）
 *
 * 値は Worker 側の `workers/anokoe/src/lib/permissions.ts` と 1:1 で対応させる。
 * ここでの判定は **UIの出し分け専用**であり、認可の本体はサーバ側の
 * authMiddleware + adminMiddleware（多層防御）。フロントを迂回されても
 * /api/admin/* は 401/403 を返すため、データは保護される。
 */
export const PERMISSIONS = {
  RESTRICT_POST: 1 << 0,    // 1
  RESTRICT_COMMENT: 1 << 1, // 2
  RESTRICT_MEDIA: 1 << 2,   // 4
  RESTRICT_VOICE: 1 << 3,   // 8
  SHADOW_BAN: 1 << 4,       // 16
  RESTRICT_DM: 1 << 5,      // 32
  RESTRICT_VOTE: 1 << 6,    // 64
  FLAG_VERIFIED: 1 << 7,    // 128
  IS_ADMIN: 1 << 8,         // 256
} as const;

export const hasFlag = (userFlags: unknown, flag: number): boolean =>
  typeof userFlags === 'number' && Number.isFinite(userFlags) && (userFlags & flag) === flag;

/** 管理者か（未ログイン・flags未取得は false）。マジックナンバーは書かない */
export const isAdmin = (user: { flags?: unknown } | null | undefined): boolean =>
  !!user && hasFlag(user.flags, PERMISSIONS.IS_ADMIN);
